import PropTypes from 'prop-types';
import React from 'react';

// material-ui
import { makeStyles } from '@mui/styles';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import useTheme from '@mui/material/styles/useTheme';

// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';

// assets
import { IconMenu2 } from '@tabler/icons';
import { IconSparkles } from '@tabler/icons-react';
import { Typography } from '@mui/material';

// style constant
const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1
    },
    headerAvatar: {
        ...theme.typography.commonAvatar,
        ...theme.typography.mediumAvatar,
        transition: 'all .2s ease-in-out',
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        '&:hover': {
            background: theme.palette.primary.main,
            color: '#fff'
        }
    },
    boxContainer: {
        width: '228px',
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            width: 'auto'
        }
    }
}));

//-----------------------|| MAIN NAVBAR / HEADER ||-----------------------//

const Header = ({ handleLeftDrawerToggle, handleCopilotoToggle }) => {
    const classes = useStyles();
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const accentGradient = 'linear-gradient(135deg, #6366f1 0%, #a855f7 55%, #06b6d4 100%)';

    return (
        <React.Fragment>
            {/* logo & toggler button */}
            <div className={classes.boxContainer}>
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <Avatar variant="rounded" className={classes.headerAvatar} onClick={handleLeftDrawerToggle} color="inherit">
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
            </div>

            {/* header search */}
            {/* <SearchSection theme="light" /> */}
            <div className={classes.grow} />
            <div className={classes.grow} />

            {/* Assistente IA - botão próprio, com cores/efeito futurista
            deliberadamente fora da paleta do resto do sistema (pedido
            explícito), só respeitando dark/light no fundo/borda */}
            <ButtonBase
                onClick={handleCopilotoToggle}
                sx={{
                    borderRadius: '999px',
                    px: 1.5,
                    py: 0.7,
                    mr: 1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.7,
                    background: isDark ? 'rgba(99,102,241,0.12)' : 'rgba(99,102,241,0.08)',
                    border: '1px solid transparent',
                    backgroundImage: isDark
                        ? `linear-gradient(rgba(20,20,35,1), rgba(20,20,35,1)), ${accentGradient}`
                        : `linear-gradient(#fff, #fff), ${accentGradient}`,
                    backgroundOrigin: 'border-box',
                    backgroundClip: 'padding-box, border-box',
                    boxShadow: isDark ? '0 0 14px rgba(99,102,241,0.35)' : '0 2px 10px rgba(99,102,241,0.2)',
                    transition: 'transform .15s ease, box-shadow .15s ease',
                    '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: isDark ? '0 0 20px rgba(99,102,241,0.55)' : '0 4px 16px rgba(99,102,241,0.3)'
                    }
                }}
            >
                <Box
                    sx={{
                        width: 20,
                        height: 20,
                        borderRadius: '7px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: accentGradient,
                        flexShrink: 0
                    }}
                >
                    <IconSparkles size={12} color="#fff" />
                </Box>
                <Typography
                    sx={{
                        fontWeight: 800,
                        fontSize: '0.78rem',
                        letterSpacing: '0.03em',
                        whiteSpace: 'nowrap',
                        display: { xs: 'none', sm: 'block' },
                        background: accentGradient,
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text'
                    }}
                >
                    LOGED IA
                </Typography>
            </ButtonBase>

            {/* notification & profile */}
            <NotificationSection />
            <ProfileSection />
        </React.Fragment>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func,
    handleCopilotoToggle: PropTypes.func
};

export default Header;
